var table_viewer_default = {
  "viewMode": "GO6U3",
  "editMode": "r4uyj",
  "container": "HJvhX",
  "cell": "FSji9"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
